import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';


export const ScrollToTop = () => {
      const { pathname } = useLocation();

      useEffect(() => {
        window.scrollTo(0, 0); // Scrolls to the top-left corner
      }, [pathname]); // Dependency array: triggers effect on pathname changes

      return null; // This component doesn't render anything visually
}
